module.exports = __webpack_public_path__ + "img/emo_55.e27b28b4.png";